import EventEmitter from 'eventemitter3';
import {
  RFI_CREATE_API_FULFILLED,
  RFI_UPDATE_API_FULFILLED,
  PUSHPIN_WORKFLOW_BEGIN,
  PUSHPIN_WORKFLOW_END,
  OPEN_ATTACHMENT,
  TOKEN_EXPIRED,
  ROUTE_CHANGE,
  SHEET_CHANGE,
  HANDLE_NAVIGATE_TO_RFI_IN_DOCUMENT,
} from '../redux/actions';

const supportedEvents = {
  RFI_CREATE_API_FULFILLED,
  RFI_UPDATE_API_FULFILLED,
  PUSHPIN_WORKFLOW_BEGIN,
  PUSHPIN_WORKFLOW_END,
  OPEN_ATTACHMENT,
  TOKEN_EXPIRED,
  ROUTE_CHANGE,
  SHEET_CHANGE,
  HANDLE_NAVIGATE_TO_RFI_IN_DOCUMENT,
};

export default class {
  constructor() {
    this.emitter = new EventEmitter();
  }

  static get events() {
    return supportedEvents;
  }

  emit(type, ...args) {
    // 1st argument to emitter.emit is the event type.
    // subsequent arguments are data, that are passed to listeners.
    this.emitter.emit(type, ...args);
  }

  listenerCount(eventName) {
    return this.emitter.listeners(eventName).length;
  }

  on(eventName, callback) {
    const { events } = this.constructor;
    if (events.hasOwnProperty(eventName)) {
      const unsubscribe = () => {
        this.emitter.removeListener(eventName, callback);
      };
      this.emitter.on(eventName, callback);
      return unsubscribe;
    } else {
      throw new Error(`Event "${eventName}" is not available in: ${JSON.stringify(Object.keys(events))}`);
    }
  }
}
